import z from 'zod';
export const Industries = z.enum([
    'FINANCE',
    'MANUFACTURING',
    'IT_AND_TELECOM',
    'RETAIL',
    'HEALTHCARE',
    'REAL_ESTATE',
    'EDUCATION',
    'SERVICE',
    'OTHER',
], '業界を選択してください');
export const Prefectures = z.enum([
    'HOKKAIDO',
    'AOMORI',
    'IWATE',
    'MIYAGI',
    'AKITA',
    'YAMAGATA',
    'FUKUSHIMA',
    'IBARAKI',
    'TOCHIGI',
    'GUNMA',
    'SAITAMA',
    'CHIBA',
    'TOKYO',
    'KANAGAWA',
    'NIIGATA',
    'TOYAMA',
    'ISHIKAWA',
    'FUKUI',
    'YAMANASHI',
    'NAGANO',
    'GIFU',
    'SHIZUOKA',
    'AICHI',
    'MIE',
    'SHIGA',
    'KYOTO',
    'OSAKA',
    'HYOGO',
    'NARA',
    'WAKAYAMA',
    'TOTTORI',
    'SHIMANE',
    'OKAYAMA',
    'HIROSHIMA',
    'YAMAGUCHI',
    'TOKUSHIMA',
    'KAGAWA',
    'EHIME',
    'KOCHI',
    'FUKUOKA',
    'SAGA',
    'NAGASAKI',
    'KUMAMOTO',
    'OITA',
    'MIYAZAKI',
    'KAGOSHIMA',
    'OKINAWA',
], '都道府県を選択してください');
export const CompanySizes = z.enum(['1_100', '101_300', '301_500', '501_1000', '1001_5000', '5001_OVER'], '従業員数を選択してください');
export const UserRoles = z.enum(['ADMIN', 'MEMBER'], '権限を選択してください');
// System user roles. Managed as a separate context from client `UserRoles`
// (independent definition; do not share type or values across the two).
export const SystemUserRoles = z.enum(['ADMIN', 'MEMBER'], '権限を選択してください');
export const Sentiments = z.enum(['JOY', 'FEAR', 'ANGER', 'SADNESS', 'NEUTRAL']);
/**
 * How a sentiment is shown to a reader. Shared so an export reads the same as
 * the screen it was taken from.
 */
export const SENTIMENT_EMOJI = {
    ANGER: '😠',
    FEAR: '😨',
    SADNESS: '😣',
    JOY: '☺️',
    NEUTRAL: '😶',
};
// --- 集計くん-related start ---
// Rails: TaskStatus.code enum (task_status.rb:4-9)
export const ReportingTaskStatusCodes = z.enum(['TASK_CREATE', 'ETL_START', 'ETL_ERROR', 'ETL_SUCCESS']);
// Rails: input_file_types attr_accessor values used in TasksController#create and Task#generate_info (task.rb:9, tasks_controller.rb:62-63)
export const ReportingInputFileTypes = z.enum([
    'RAW_DATA_ATTRIBUTES_MASTER',
    'RAW_DATA_QUESTIONS_MASTER',
    'RAW_DATA_CURRENT_SYSTEM',
    'RAW_DATA_CURRENT_SYSTEM_ATTRS',
    'RAW_DATA_MARKSHEET',
    'RAW_DATA_TARO',
    'RAW_DATA_TARO_SETTINGS',
    'RAW_DATA_GOOGLE_FORMS',
]);
export const ReportingTaskTypes = z.enum(['NEW_SURVEY', 'OVERWRITE_SURVEY', 'ETL_ONLY']);
/** Lifecycle status of an async rawdata import pipeline run (`survey_import_jobs.status`). */
export const SurveyImportJobStatus = z.enum([
    'TRIGGERED',
    'IMPORT_COMPLETED',
    'IMPORT_FAILED',
    'SUMMARIZE_COMPLETED',
    'SUMMARIZE_FAILED',
    'COMMENT_ANALYSIS_COMPLETED',
    'COMMENT_ANALYSIS_FAILED',
    'FAILED_UNKNOWN',
]);
// --- 集計くん-related end ---
export const QuestionTypes = z.enum(['select', 'number', 'text']);
export const AttributeSettingType = z.enum(['DEPARTMENT'], '属性タイプを選択してください');
//# sourceMappingURL=enums.js.map